import { FC, useEffect, useRef, useState } from "react";
import styles from "./password-changing.module.scss";
import { useMutation } from "react-query";
import loginService from "../../service/login/login";
import { PassChangeFormData } from "../../models/registrationModel";

const PasswordChanging: FC = () => {
  const [formData, setFormData] = useState({
    Email: "",
    Password: "",
  });

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    // console.log(formData);
  }

  return (
    <div className={styles["passwordChanging_container"]}>
      <div className="passwordChanging_box">

        <form onSubmit={handleSubmit} className="input_sec">
          <div className="input_box">
            <span className="label_text">帳號</span>
            <input
              id="email"
              name="Email"
              type="email"
              value={formData.Email}
              onChange={handleChange}
              className="sigin_input"
              placeholder="請輸入您的帳號"
            />
          </div>
          <div className="input_box">

            <span className="label_text">密碼</span>
            <input
              id="password"
              name="Password"
              type="password"
              value={formData.Password}
              onChange={handleChange}
              className="sigin_input"
              placeholder="請輸入您的密碼"
            />
          </div>
          <button type="submit" className="submit_btn">
            登入
          </button>
        </form>

      </div>
    </div>
  );
};
export default PasswordChanging;
